module.exports = __webpack_public_path__ + "img/icon17.1ec696b6.png";